import { Icon } from './Icon'

/**
 * The default dog colour mobile stamps onto a header when a dog has none
 * (`0xFFFA6400`), kept here so the section and the picker draw an uncoloured
 * dog the same way the app does.
 */
const DEFAULT_DOG_ARGB = 0xfffa6400

/** Packed ARGB int (as mobile stores a dog colour) → a `#RRGGBB` CSS colour. */
export function dogArgbToCss(argb: number | null | undefined): string {
  const value = argb ?? DEFAULT_DOG_ARGB
  return `#${(value & 0xffffff).toString(16).padStart(6, '0')}`
}

/**
 * A dog's coloured round avatar — the web form of the app's dog marker: the
 * dog glyph on the dog's own colour. Presentation only.
 */
export function PlanDogAvatar({
  colorArgb,
  size = 36,
}: {
  colorArgb?: number | null
  size?: number
}) {
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: 999,
        flexShrink: 0,
        background: dogArgbToCss(colorArgb),
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Icon name="dog" size={Math.round(size * 0.55)} />
    </div>
  )
}
